/* Commonly used individual facet functions */
import { computed } from 'vue';
import useFacets from './useFacets';

export default function useFacet(props) {
  const facetsUtil = useFacets();

  const facet = computed(() => props.facet);
  const facetName = computed(() => props.facet.name);

  // wrapping common functions with a current facet specific version:
  const replaceFacetSelectedValues = (selectedFacet, triggerUpdate = true) => {
    facetsUtil.replaceSelectedValues(selectedFacet);
    /* istanbul ignore else */
    if (triggerUpdate) {
      facetsUtil.triggerSelectedFacetsUpdate();
    }
  };
  const removeFacetCheckboxValuesByValue = (value) => facetsUtil.removeCheckboxValuesByValue(facetName.value, value);
  const addFacetCheckboxValues = (newValue) => facetsUtil.addCheckboxValues(facetName.value, newValue);

  return {
    ...facetsUtil,
    facet,
    facetName,
    replaceFacetSelectedValues,
    removeFacetCheckboxValuesByValue,
    addFacetCheckboxValues,
  };
}
